const keepFlashMessagesBesideNavBar = () => {
  // Fonction pour détecter si on est sur la page d'accueil
  const isHomepage = () => {
    return window.location.pathname === '/' || window.location.pathname === ''
  }

  // Positionnement fixe des alertes - toujours à la même hauteur
  const setFlashPosition = () => {
    const flashMessage = document.querySelector('#flashes .alert')
    if (flashMessage) {
      flashMessage.style.top = '100px'

      // Appliquer les styles spécifiques à la page d'accueil
      if (isHomepage()) {
        flashMessage.style.right = 'auto'
        flashMessage.style.left = '20px'
        flashMessage.style.animation = 'slideInLeft 0.4s ease-out'
      } else {
        flashMessage.style.right = '20px'
        flashMessage.style.left = 'auto'
        flashMessage.style.animation = 'slideInRight 0.4s ease-out'
      }
    }
  }

  // Positionner immédiatement
  setFlashPosition()

  // Positionner lors du scroll pour maintenir la position
  document.addEventListener('scroll', setFlashPosition)

  // Fonction pour auto-fermer les alertes
  const autoCloseAlerts = () => {
    const alerts = document.querySelectorAll('#flashes .alert')
    alerts.forEach(alert => {
      setTimeout(() => {
        if (alert && alert.parentNode) {
          alert.classList.add('fade-out')
          setTimeout(() => {
            if (alert && alert.parentNode) {
              alert.remove()
            }
          }, 300)
        }
      }, 5000)
    })
  }

  // Exécuter immédiatement pour les alertes existantes
  autoCloseAlerts()

  // Observer les changements dans le conteneur #flashes
  const flashesContainer = document.querySelector('#flashes')
  if (flashesContainer) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.classList.contains('alert')) {
              // Nouvelle alerte détectée, lancer l'auto-fermeture
              setTimeout(() => {
                if (node && node.parentNode) {
                  node.classList.add('fade-out')
                  setTimeout(() => {
                    if (node && node.parentNode) {
                      node.remove()
                    }
                  }, 300)
                }
              }, 5000)
            }
          })
        }
      })
    })

    observer.observe(flashesContainer, {
      childList: true,
      subtree: true
    })
  }
}

export { keepFlashMessagesBesideNavBar }
